<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-input ttLabel="belongto" [ttModel]="setting.category_name" ttReadonly></tt-input>
        <tt-input ttLabel="category_name" ttFocus [(ttModel)]="categoryNameNew" ttShowClearButton [ttButtons]="categoryNameButtons"></tt-input>
    </tt-card>

    <tt-list [ttData]="itemsListNotLinked" ttBackStyle [ttGoto]="false" (ttClick)="goBackToPrevious($event)" [ttFilter]="categoryNameNew"></tt-list>
</tt-page>
